module["exports"] = [
  "#{street_name} #{building_number}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/street_address.js
// module id = 1006
// module chunks = 0